module.exports = __webpack_public_path__ + "static/draft-949686dc4776b959101e5cd4f7da3a7a.png";